import { CloudProvider } from "../../../../../services/cloudchipr.api";

export const billingStatusProviders: CloudProvider[] = [
  "gcp",
  "aws",
  "azure",
  "eks",
  "confluent",
  "datadog",
  "snowflake",
  "mongo",
];
